import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Sidebar from "./Sidebar";

export default function Layout() {
  const [navOpen, setNavOpen] = useState(false);

  useEffect(() => {
    if (!navOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setNavOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [navOpen]);

  useEffect(() => {
    document.body.style.overflow = navOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [navOpen]);

  return (
    <div className="relative min-h-screen bg-background">
      <div className="pointer-events-none fixed inset-0 bg-aurora" />

      <header className="fixed inset-x-0 top-0 z-40 flex h-14 items-center gap-3 border-b border-border/50 bg-card/80 px-3 backdrop-blur-xl md:hidden">
        <button
          type="button"
          aria-label={navOpen ? "Zamknij menu" : "Otwórz menu"}
          aria-expanded={navOpen}
          className="inline-flex h-10 w-10 items-center justify-center rounded-lg text-foreground hover:bg-accent/50"
          onClick={() => setNavOpen((v) => !v)}
        >
          {navOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
        <div className="min-w-0">
          <div className="truncate text-sm font-semibold">Kasia Zaręba</div>
          <div className="text-[11px] text-muted-foreground">Dashboard</div>
        </div>
      </header>

      {navOpen ? (
        <button
          type="button"
          aria-label="Zamknij menu"
          className="fixed inset-0 z-40 bg-black/50 md:hidden"
          onClick={() => setNavOpen(false)}
        />
      ) : null}

      <Sidebar mobileOpen={navOpen} onNavigate={() => setNavOpen(false)} />

      <main className="relative min-h-screen overflow-x-hidden px-3 pb-6 pt-[4.25rem] md:ml-64 md:px-8 md:py-8 md:pt-8">
        <Outlet />
      </main>
    </div>
  );
}
